/* --- inline script #0 --- */

/* ============================================================
   QUIZ DATA
   Archetypes: 0=Depleted Parent, 1=Doom Scroller,
               2=Burned-Out Achiever, 3=Wired Worrier,
               4=Last On Your Own List
   ============================================================ */

const ATTRIBUTION_URL = "https://www.amazon.com/Saffron-Extract-88-5mg-Supplement-Serotonin/dp/B0FQDZ8YVB?maas=maas_adg_F35089F06C2D2E0528FF70CF24387DA7_afap_abs&ref_=aa_maas&tag=maas";
const QUIZ_URL = window.location.href;

/* ----------------------------------------------------------------
   KLAVIYO ENDPOINT - Replace this URL with your actual
   Klaviyo email capture endpoint before deploying.
   Format: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe'
   with list_id in the body, or use your Klaviyo API v3 endpoint.
---------------------------------------------------------------- */
const KLAVIYO_ENDPOINT = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
const KLAVIYO_LIST_ID  = "TsEKGc"; // Renewal Quiz - Subscribers list

const questions = [
  {
    text: "How do you typically feel on Sunday evening?",
    emoji: "numi-mirror",
    brainTeaser: false,
    options: [
      { text: "Dread. The week starts again and I haven't recovered from the last one.", a: 0 },
      { text: "Wired - I'm already mentally running through what needs to happen.", a: 2 },
      { text: "Blank. I spent the day trying to recover and still don't feel restored.", a: 4 },
      { text: "Guilty. I either worked when I shouldn't have or rested when I shouldn't have.", a: 3 },
      { text: "Fine - but the enjoyment I used to feel on weekends has been gone for a while.", a: 1 },
      { text: "Okay, mostly. Life is full but I'm managing - some days better than others.", a: 5 }
    ]
  },
  {
    text: "Be honest - what's your real relationship with your phone?",
    emoji: "numi-phone",
    brainTeaser: false,
    options: [
      { text: "It's a problem. I know it's a problem. I still can't put it down.", a: 1 },
      { text: "I check it compulsively, especially at night, and then I can't sleep", a: 3 },
      { text: "It's how I stay connected to life outside of caregiving - it's my window to something else", a: 0 },
      { text: "I use it to coordinate everyone else's lives - appointments, schedules, reminders for multiple people", a: 4 },
      { text: "Work email after hours. Not really scrolling - just always on for work", a: 2 },
      { text: "It's a tool. I use it, but I can put it down without much struggle.", a: 5 }
    ]
  },
  {
    text: "When was the last time you felt genuinely, effortlessly happy - no effort required?",
    emoji: "numi-sunrise",
    brainTeaser: false,
    options: [
      { text: "I feel happiness, but it's always a little tense - like I'm waiting for something to go wrong", a: 3 },
      { text: "Years ago. Before everything got this heavy - when life was hard but somehow still felt alive", a: 0 },
      { text: "I remember contentment. Effortless happy feels far away - I've been running on duty for so long", a: 4 },
      { text: "A few years ago. I've been achieving things since then but the joy kind of faded", a: 2 },
      { text: "Honestly? Sometimes online. Real life feels kind of flat lately.", a: 1 },
      { text: "Recently, actually. Life has good moments and hard moments - that's normal.", a: 5 }
    ]
  },
  {
    text: "Describe your relationship with sleep right now.",
    emoji: "numi-breath",
    brainTeaser: false,
    options: [
      { text: "Interrupted constantly. I'm always half-awake, accounting for whoever needs me next.", a: 4 },
      { text: "Fine technically - but I wake up already behind, never truly restored", a: 2 },
      { text: "I'm on my phone until midnight and then wonder why I'm exhausted", a: 1 },
      { text: "Broken. I wake in the night and can't fall back - my mind is already running.", a: 0 },
      { text: "I lie awake reviewing conversations, planning for things that haven't happened yet", a: 3 },
      { text: "Decent overall. Some nights are restless but I sleep pretty well most of the time.", a: 5 }
    ]
  },
  {
    text: "What has changed most noticeably about you in the past 2-3 years?",
    emoji: "numi-cycle",
    brainTeaser: false,
    options: [
      { text: "How wins feel. The success is real - the feeling that used to come with it is gone", a: 2 },
      { text: "My sense of self. I'm whoever everyone needs me to be. I'm not sure what else anymore.", a: 0 },
      { text: "My nervous system. Everything feels a little louder and sharper than it used to", a: 3 },
      { text: "My energy. Caring for everyone else means running on empty has become my baseline", a: 4 },
      { text: "My ability to enjoy things that don't involve a screen", a: 1 },
      { text: "Not much, honestly. I'm pretty much the same person I was a few years ago.", a: 5 }
    ]
  },
  {
    text: "When you have unstructured time with no demands, what actually happens?",
    emoji: "numi-bolt",
    brainTeaser: false,
    options: [
      { text: "I pick up my phone almost immediately, without consciously deciding to.", a: 1 },
      { text: "I feel vaguely guilty and start filling the time with something productive.", a: 2 },
      { text: "I'm not sure what I want to do. I've been responding to other people's needs for so long.", a: 4 },
      { text: "My brain starts generating things to worry about within a few minutes.", a: 3 },
      { text: "Relief - then flatness. The rest doesn't feel as good as it should.", a: 0 },
      { text: "I'd do something I enjoy. Probably work on a hobby or see a friend.", a: 5 }
    ]
  },
  {
    text: "Imagine a full day completely to yourself - no responsibilities, no one needing you. What does that actually feel like?",
    emoji: "numi-sunrise",
    brainTeaser: false,
    options: [
      { text: "I'd spend most of it on my phone. I'm a little scared of how little I can enjoy actual quiet.", a: 1 },
      { text: "Nice in theory. In practice I'd work, plan, or feel vaguely guilty about not working.", a: 2 },
      { text: "I'd spend the first few hours trying to figure out what I even want. It's been that long.", a: 4 },
      { text: "I can't visualize it. A full day with no one needing me doesn't exist in my life right now.", a: 0 },
      { text: "Anxious at first. My brain would find something to worry about even without the usual input.", a: 3 },
      { text: "Peaceful, probably. A day to myself sounds restorative.", a: 5 }
    ]
  },
  {
    text: "When something good happens - a compliment, a win, a moment you'd normally enjoy - what do you notice?",
    emoji: "numi-target",
    brainTeaser: false,
    options: [
      { text: "I note it, then immediately move on to the next thing on the list.", a: 2 },
      { text: "I feel it briefly, then the worry about what could go wrong returns.", a: 3 },
      { text: "It registers, but doesn't land the way it once would have. Things feel muted.", a: 0 },
      { text: "I'm too busy managing everyone else to give it much space.", a: 4 },
      { text: "I can't quite feel it in the moment - I usually need a screen to decompress first.", a: 1 },
      { text: "I feel it and I appreciate it. It's a normal part of my day.", a: 5 }
    ]
  },
  {
    text: "What does your body feel like by 3pm on a typical weekday?",
    emoji: "numi-bolt",
    brainTeaser: false,
    options: [
      { text: "Heavy. Like I've been carrying weight since before I woke up.", a: 0 },
      { text: "Wired but unfocused - I've had more caffeine than I should and I'm still not sharp.", a: 2 },
      { text: "My brain is buzzing with background noise - half-finished thoughts, low-grade tension.", a: 3 },
      { text: "Completely flat. I've given everything I have and there's nothing left.", a: 4 },
      { text: "Restless. I want stimulation but nothing real sounds appealing.", a: 1 },
      { text: "Steady. I'm tired but it's the good kind - a day's work done.", a: 5 }
    ]
  },
  {
    text: "Brain Teaser: Which of these surprises you most?",
    emoji: "numi-brain",
    brainTeaser: true,
    options: [
      {
        text: "95% of your serotonin is made in your gut, not your brain",
        reveal: "True. The gut-brain axis means digestive health directly affects mood neurotransmitter production - which is part of why saffron's bioavailability pathway through the gut matters."
      },
      {
        text: "Dopamine fires harder in anticipation of a reward than during the reward itself",
        reveal: "True. The 'wanting' system and the 'liking' system are neurologically separate. This is why social media keeps you scrolling - the anticipation loop never fully resolves."
      },
      {
        text: "Chronic social media use measurably lowers dopamine synthesis in the brain",
        reveal: "True. Neuroimaging studies have linked habitual social media use to reduced dopamine signaling in reward-governing brain regions - the same areas responsible for motivation, satisfaction, and follow-through."
      },
      {
        text: "Saffron's crocetin compounds have been studied for interaction with the NMDA receptor pathway",
        reveal: "True. The NMDA receptor pathway plays a documented role in mood regulation and serotonin signaling. Saffron's crocetin compounds have been studied for their interaction with this system in peer-reviewed research."
      }
    ]
  }
];

/* ============================================================ STATE */
let state = {
  currentQ: 0,
  scores: [0, 0, 0, 0, 0, 0],
  selectedOpt: null,
  brainTeaserPicked: null,
  quizStarted: false,
  autoAdvTimer: null
};

/* ============================================================ INIT */
function scrollToQuiz() {
  document.getElementById('dq-quiz-section').scrollIntoView({ behavior: 'smooth', block: 'start' });
  setTimeout(startQuiz, 600);
}

function startQuiz() {
  state = { currentQ: 0, scores: [0,0,0,0,0,0], selectedOpt: null, brainTeaserPicked: null, quizStarted: true, autoAdvTimer: null };
  document.getElementById('dq-start-card').style.display = 'none';
  document.getElementById('dq-progress-wrap').style.display = 'block';
  document.getElementById('dq-question-card').style.display = 'block';
  renderQuestion(0);
}

/* ============================================================ RENDER QUESTION */
function renderQuestion(idx) {
  const q = questions[idx];
  state.selectedOpt = null;
  state.brainTeaserPicked = null;

  // Progress
  document.getElementById('dq-progress-count').textContent = (idx + 1) + ' / ' + questions.length;
  document.getElementById('dq-progress-fill').style.width = (((idx) / questions.length) * 100) + '%';

  // Question meta
  const isBT = q.brainTeaser;
  document.getElementById('dq-q-num').textContent = 'QUESTION ' + (idx + 1);
  document.getElementById('dq-brain-badge').classList.toggle('hidden', !isBT);
  const emoji = q.emoji ? `<span class="dq-q-emoji" style="font-size:0;display:inline-block;margin-right:10px;vertical-align:-0.2em;"><svg class="ni" style="width:36px;height:36px"><use href="#${q.emoji}"/></svg></span>` : '';
  document.getElementById('dq-q-text').innerHTML = emoji + q.text;
  document.getElementById('dq-brain-reveal').style.display = 'none';
  document.getElementById('dq-brain-reveal').innerHTML = '';

  // Options
  const optWrap = document.getElementById('dq-options');
  optWrap.innerHTML = '';
  q.options.forEach((opt, i) => {
    const btn = document.createElement('button');
    btn.className = 'dq-opt';
    btn.textContent = opt.text;
    btn.setAttribute('data-idx', i);
    if (isBT) {
      btn.onclick = () => selectBrainTeaser(i, opt.reveal);
    } else {
      btn.onclick = () => selectOption(i, opt.a);
    }
    optWrap.appendChild(btn);
  });

  // Back button — visible on Q2+
  const backBtn = document.getElementById('dq-btn-back');
  backBtn.classList.toggle('visible', idx > 0);

  // Next button
  const nextBtn = document.getElementById('dq-btn-next');
  nextBtn.classList.remove('visible');
  nextBtn.innerHTML = (idx < questions.length - 1) ? 'Next Question <svg class="ni"><use href="#numi-arrow-right"/></svg>' : 'See My Result <svg class="ni"><use href="#numi-arrow-right"/></svg>';

  // Animate in
  const card = document.getElementById('dq-question-card');
  card.style.animation = 'none';
  requestAnimationFrame(() => { card.style.animation = 'fadeSlideIn 0.35s ease forwards'; });
}

/* ============================================================ SELECT OPTION */
function selectOption(optIdx, archetypeIdx) {
  // Allow re-selection: undo previous score if already picked
  if (state.selectedOpt === optIdx) return;
  if (state.selectedOpt !== null) {
    const prevA = questions[state.currentQ].options[state.selectedOpt].a;
    state.scores[prevA] -= 1;
  }
  state.selectedOpt = optIdx;

  // Score
  state.scores[archetypeIdx] += 1;

  // Visual - update selection without locking so user can change
  const opts = document.querySelectorAll('#dq-options .dq-opt');
  opts.forEach((o) => o.classList.remove('dq-opt-selected'));
  opts[optIdx].classList.add('dq-opt-selected');

  // Auto-advance after brief delay so user sees their selection highlight
  clearTimeout(state.autoAdvTimer);
  state.autoAdvTimer = setTimeout(() => {
    nextQuestion();
  }, 320);
}

/* ============================================================ BRAIN TEASER */
function selectBrainTeaser(optIdx, reveal) {
  // Allow re-selection - same option is a no-op
  if (state.brainTeaserPicked === optIdx) return;
  state.brainTeaserPicked = optIdx;

  // Visual - update selection without locking
  const opts = document.querySelectorAll('#dq-options .dq-opt');
  opts.forEach((o) => o.classList.remove('dq-opt-selected'));
  opts[optIdx].classList.add('dq-opt-selected');

  // Update reveal panel with this option's fact — strip "True. " or "False. " prefix
  const revealEl = document.getElementById('dq-brain-reveal');
  revealEl.style.display = 'block';
  // Remove "True. " or "False. " from start of reveal text
  const cleanReveal = reveal.replace(/^(True|False)\.\s+/, '');
  revealEl.innerHTML = '<strong>Here\'s why that\'s fascinating:</strong> ' + cleanReveal;

  const nextBtn = document.getElementById('dq-btn-next');
  nextBtn.innerHTML = 'See My Result <svg class="ni"><use href="#numi-arrow-right"/></svg>';
  nextBtn.classList.add('visible');
}

/* ============================================================ NEXT QUESTION */
function nextQuestion() {
  clearTimeout(state.autoAdvTimer);
  const total = questions.length;
  const next = state.currentQ + 1;

  if (next >= total) {
    showScoring();
    return;
  }

  /* ============================================================
     PATH A: Adaptive-End Branching (2026-05-23)
     If the user has answered Q7 or later (state.currentQ >= 6)
     AND any single archetype score in state.scores[0..4] has
     reached 4 (high-confidence concentration), skip remaining
     questions and route straight to scoring. Preserves the
     existing Balanced-baseline early-exit in showResult()
     (state.scores[5] >= 6).
     ============================================================ */
  if (state.currentQ >= 6) {
    var pathAMax = 0;
    for (var pa_i = 0; pa_i < 5; pa_i++) {
      if (state.scores[pa_i] > pathAMax) pathAMax = state.scores[pa_i];
    }
    if (pathAMax >= 4) {
      showScoring();
      return;
    }
  }

  state.currentQ = next;
  renderQuestion(next);
}

/* ============================================================ PREV QUESTION */
function prevQuestion() {
  clearTimeout(state.autoAdvTimer);
  if (state.currentQ === 0) return;

  // Undo the score for the current question if an answer was selected
  if (state.selectedOpt !== null) {
    const q = questions[state.currentQ];
    if (q.type !== 'brain-teaser') {
      const prevA = q.options[state.selectedOpt].a;
      state.scores[prevA] = Math.max(0, state.scores[prevA] - 1);
    }
  }

  state.currentQ -= 1;
  renderQuestion(state.currentQ);
}

/* ============================================================ SCORING */
function showScoring() {
  document.getElementById('dq-question-card').style.display = 'none';
  document.getElementById('dq-progress-wrap').style.display = 'none';
  document.getElementById('dq-scoring').style.display = 'block';

  // Update progress to 100%
  document.getElementById('dq-progress-fill').style.width = '100%';

  setTimeout(() => {
    document.getElementById('dq-scoring').style.display = 'none';
    showResult();
  }, 2200);
}

/* ============================================================ SHOW RESULT */
function showResult() {
  // Check if user selected "balanced" answer 6+ times
  if (state.scores[5] >= 6) {
    document.getElementById('dq-quiz-section').style.display = 'none';
    const resultsEl = document.getElementById('dq-results');
    resultsEl.style.display = 'block';
    document.querySelectorAll('.dq-result').forEach(r => r.classList.remove('active'));
    document.getElementById('result-5').classList.add('active');
    setTimeout(() => updateGaugeForResult(5), 300);
    resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  // Find highest score among types 0-4 (first max wins ties)
  let maxScore = -1;
  let winnerIdx = 0;
  for (let i = 0; i < 5; i++) {
    if (state.scores[i] > maxScore) { maxScore = state.scores[i]; winnerIdx = i; }
  }

  document.getElementById('dq-quiz-section').style.display = 'none';
  const resultsEl = document.getElementById('dq-results');
  resultsEl.style.display = 'block';

  // Show the winning result
  document.querySelectorAll('.dq-result').forEach(r => r.classList.remove('active'));
  document.getElementById('result-' + winnerIdx).classList.add('active');

  // Update gauge dynamically based on actual answers
  setTimeout(() => updateGaugeForResult(winnerIdx), 300);

  // Scroll to results
  resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ============================================================ EMAIL CAPTURE */
function submitEmail(inputId, successId) {
  const emailEl = document.getElementById(inputId);
  const email = emailEl.value.trim();

  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    emailEl.style.borderColor = '#d3140f';
    emailEl.focus();
    return;
  }
  emailEl.style.borderColor = '';

  // Determine which result is showing (to tag by archetype)
  let archetype = 'unknown';
  const archetypeNames = ['depleted-parent','doom-scroller','burned-out-achiever','wired-worrier','last-on-own-list','balanced'];
  // Title Case mapping for Klaviyo 'Dopamine Type' profile property (added 2026-05-26)
  // Slug stays internal; Title Case is what flow filters in Klaviyo match against.
  const archetypeTitleCase = {
    'depleted-parent': 'Depleted Parent',
    'doom-scroller': 'Doom Scroller',
    'burned-out-achiever': 'Burned-Out Achiever',
    'wired-worrier': 'Wired Worrier',
    'last-on-own-list': 'Last On Your Own List',
    'balanced': 'Balanced'
  };
  document.querySelectorAll('.dq-result').forEach((r, i) => {
    if (r.classList.contains('active')) archetype = archetypeNames[i];
  });
  const dopamineTypeValue = archetypeTitleCase[archetype] || archetype;

  /* ----------------------------------------------------------------
     KLAVIYO INTEGRATION — live, wired to TsEKGc (Renewal Quiz - Subscribers)
     Public key U9ZAuU. Identifies profile, fires quiz-completed event,
     and subscribes to list. Same pattern as Scavenger Hunt page.
     Example body reference:
     {
       "g": "YOUR_LIST_ID",
       "email": email,
       "$fields": "$source",
       "$source": "Dopamine Renewal Style Quiz -" + archetype
     }
     Headers: { "Content-Type": "application/x-www-form-urlencoded" }
     Endpoint: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe"
  ---------------------------------------------------------------- */

  // Klaviyo identify + track event
  if (window._learnq) {
    window._learnq.push(['identify', { '$email': email, 'Dopamine Type': dopamineTypeValue }]);
    window._learnq.push(['track', 'Dopamine Quiz Completed', {
      archetype: archetype,
      source: 'Dopamine Renewal Quiz'
    }]);
  }

  // Subscribe to Klaviyo list (fire-and-forget)
  const params = new URLSearchParams({
    g: KLAVIYO_LIST_ID,
    email: email,
    '$fields': '$source,$consent_method,Dopamine Type',
    '$source': 'Dopamine Renewal Quiz - ' + archetype,
    '$consent_method': 'Dopamine Renewal Quiz opt-in',
    'Dopamine Type': dopamineTypeValue
  });
  fetch(KLAVIYO_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: params
  }).catch(() => {}); // fire-and-forget; show success regardless

  // Show success state
  document.getElementById(successId).classList.add('show');
  emailEl.parentElement.style.display = 'none';
}

/* ============================================================ SHARE */
function shareQuiz(method) {
  const url = QUIZ_URL;
  const text = "I just took a dopamine renewal style quiz and it was uncomfortably accurate. Take it and tell me what your style is:";

  if (method === 'copy') {
    navigator.clipboard.writeText(url).then(() => {
      // Brief visual feedback
      const btns = document.querySelectorAll('.dq-btn-share');
      btns.forEach(b => { if (b.textContent.includes('Copy')) { b.innerHTML = '<svg class="ni"><use href="#numi-check"/></svg> Copied!'; setTimeout(() => { b.innerHTML = '<svg class="ni"><use href="#numi-link"/></svg> Copy Link'; }, 2000); } });
    }).catch(() => {
      prompt('Copy this link:', url);
    });
  } else if (method === 'text') {
    const smsUrl = 'sms:?body=' + encodeURIComponent(text + ' ' + url);
    window.open(smsUrl);
  }
}

/* ============================================================ SHOW RESULT DIRECT (explore other types) */
function showResultDirect(idx) {
  document.getElementById('dq-quiz-section').style.display = 'none';
  const resultsEl = document.getElementById('dq-results');
  resultsEl.style.display = 'block';
  document.querySelectorAll('.dq-result').forEach(r => r.classList.remove('active'));
  document.getElementById('result-' + idx).classList.add('active');
  setTimeout(() => updateGaugeForResult(idx), 300);
  resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ============================================================ RETAKE */
function retakeQuiz() {
  document.getElementById('dq-results').style.display = 'none';
  document.querySelectorAll('.dq-result').forEach(r => r.classList.remove('active'));
  document.getElementById('dq-quiz-section').style.display = 'block';
  document.getElementById('dq-start-card').style.display = 'block';
  document.getElementById('dq-progress-wrap').style.display = 'none';
  document.getElementById('dq-question-card').style.display = 'none';
  document.getElementById('dq-scoring').style.display = 'none';
  state = { currentQ: 0, scores: [0,0,0,0,0,0], selectedOpt: null, brainTeaserPicked: null, quizStarted: false };
  document.getElementById('dq-quiz-section').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* ============================================================ THEME TOGGLE */
const themeBtn = document.getElementById('dq-theme-btn');
const dqRoot = document.getElementById('dq-root');
themeBtn.addEventListener('click', () => {
  const isLight = dqRoot.getAttribute('data-theme') === 'light';
  dqRoot.setAttribute('data-theme', isLight ? 'dark' : 'light');
  themeBtn.setAttribute('aria-label', isLight ? 'Switch to light mode' : 'Switch to dark mode');
});

/* ============================================================ SCROLL DOTS + ARROW NAV */
const archScrollEl = document.getElementById('dq-arch-scroll');
const dots = document.querySelectorAll('.dq-scroll-dot');
const CARD_WIDTH = 230 + 16; // card min-width + gap
let archIdx = 0;
const ARCH_COUNT = 5;

function archUpdateNav() {
  dots.forEach((d, i) => {
    const isActive = i === archIdx;
    d.classList.toggle('active', isActive);
    // Force inline styles so GemPages can't strip them
    d.style.setProperty('width',       isActive ? '18px' : '6px',   'important');
    d.style.setProperty('height',      '6px',                        'important');
    d.style.setProperty('border-radius', isActive ? '3px' : '50%',  'important');
    d.style.setProperty('background',  isActive ? '#d3140f' : 'rgba(0,0,0,0.15)', 'important');
    d.style.setProperty('flex-shrink', '0',                          'important');
  });
  const prevBtn = document.getElementById('dq-arch-prev');
  const nextBtn = document.getElementById('dq-arch-next');
  if (prevBtn) {
    prevBtn.disabled = archIdx === 0;
    prevBtn.style.setProperty('opacity', archIdx === 0 ? '0.25' : '1', 'important');
  }
  if (nextBtn) {
    nextBtn.disabled = archIdx === ARCH_COUNT - 1;
    nextBtn.style.setProperty('opacity', archIdx === ARCH_COUNT - 1 ? '0.25' : '1', 'important');
  }
}

function archScroll(dir) {
  archIdx = Math.max(0, Math.min(ARCH_COUNT - 1, archIdx + dir));
  archScrollEl.scrollTo({ left: archIdx * CARD_WIDTH, behavior: 'smooth' });
  archUpdateNav();
}

archScrollEl.addEventListener('scroll', () => {
  archIdx = Math.round(archScrollEl.scrollLeft / CARD_WIDTH);
  archUpdateNav();
}, { passive: true });

dots.forEach((dot, i) => {
  dot.addEventListener('click', () => {
    archIdx = i;
    archScrollEl.scrollTo({ left: i * CARD_WIDTH, behavior: 'smooth' });
    archUpdateNav();
  });
});

archUpdateNav(); // set initial disabled state


/* ============================================================ DYNAMIC GAUGE */
/* Adjusts displayed dopamine profile gauge + bars based on actual quiz answers */
const ARCHETYPE_PROFILES = {
  0: { floor: 14, ceiling: 55, bars: { Energy:[14,52], Mood:[20,54], Reward:[16,50], Rest:[18,56] } },
  1: { floor: 22, ceiling: 60, bars: { Energy:[38,65], Mood:[18,52], Reward:[12,48], Rest:[30,62] } },
  2: { floor: 20, ceiling: 58, bars: { Energy:[54,72], Mood:[19,52], Reward:[11,46], Rest:[36,64] } },
  3: { floor: 28, ceiling: 65, bars: { Energy:[43,68], Mood:[16,50], Reward:[38,66], Rest:[22,58] } },
  4: { floor: 12, ceiling: 52, bars: { Energy:[17,50], Mood:[21,55], Reward:[13,48], Rest:[19,54] } },
  5: { floor: 48, ceiling: 72, bars: { Energy:[48,70], Mood:[54,74], Reward:[52,72], Rest:[56,76] } }
};

function updateGaugeForResult(archetypeIdx) {
  const profile = ARCHETYPE_PROFILES[archetypeIdx];
  if (!profile) return;

  // How many non-balanced deficit answers for this archetype? (out of 9 scoreable qs)
  const deficitScore = state.scores[archetypeIdx] || 0;
  const balancedScore = state.scores[5] || 0;
  const total = deficitScore + balancedScore;
  // deficit_ratio: 1.0 = all deficit, 0.0 = all balanced
  const deficitRatio = total > 0 ? deficitScore / Math.max(total, 1) : 0.7;

  // Final gauge pct: lower deficit_ratio = higher reading
  const pct = Math.round(profile.floor + (1 - deficitRatio) * (profile.ceiling - profile.floor));

  // SVG circumference for r=44 circle = 2π*44 ≈ 276.46
  const C = 276.46;
  const dashVal = (pct / 100) * C;

  const resultEl = document.getElementById('result-' + archetypeIdx);
  if (!resultEl) return;

  // Update gauge fill
  const gaugeFill = resultEl.querySelector('.dq-gauge-fill');
  if (gaugeFill) {
    gaugeFill.style.setProperty('--g', dashVal.toFixed(1));
    // Reset animation
    gaugeFill.style.strokeDasharray = '0 276.46';
    setTimeout(() => {
      gaugeFill.style.transition = 'stroke-dasharray 1.4s cubic-bezier(0.4,0,0.2,1)';
      gaugeFill.style.strokeDasharray = dashVal.toFixed(1) + ' 276.46';
    }, 50);
  }

  // Update pct label
  const gaugePct = resultEl.querySelector('.dq-gauge-pct');
  if (gaugePct) gaugePct.textContent = pct + '%';

  // Update bars
  const barNames = ['Energy', 'Mood', 'Reward', 'Rest'];
  const barFills = resultEl.querySelectorAll('.dq-bar-fill');
  const barVals  = resultEl.querySelectorAll('.dq-bar-val');
  barNames.forEach((name, i) => {
    const [baseVal, maxVal] = profile.bars[name];
    const barPct = Math.round(baseVal + (1 - deficitRatio) * (maxVal - baseVal));
    if (barFills[i]) {
      barFills[i].style.setProperty('--w', barPct + '%');
      barFills[i].style.width = '0';
      setTimeout(() => {
        barFills[i].style.transition = 'width 0.9s ease';
        barFills[i].style.width = barPct + '%';
      }, 100 + i * 80);
    }
    if (barVals[i]) barVals[i].textContent = barPct + '%';
  });
}

